var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import Skeleton, { withSkeleton } from '../../Skeleton';
var SellingPointsList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0.75rem 0;\n  padding: 1rem 0.25rem 1rem 1.75rem;\n  background: #f4f4f4;\n  text-align: left;\n  font-size: calc(", " - 3px);\n"], ["\n  margin: 0.75rem 0;\n  padding: 1rem 0.25rem 1rem 1.75rem;\n  background: #f4f4f4;\n  text-align: left;\n  font-size: calc(", " - 3px);\n"])), function (_a) {
    var theme = _a.theme;
    return theme.global.baseFontSize;
});
var SellingPoints = function (_a) {
    var sellingPoints = _a.sellingPoints;
    return sellingPoints && sellingPoints.length > 0 ? (React.createElement(SellingPointsList, { "data-testid": "sellingPoints" }, sellingPoints.map(function (data) { return (React.createElement("li", { key: data }, data)); }))) : null;
};
export default withSkeleton(SellingPoints, function () { return React.createElement(Skeleton, { height: "6rem", width: "80%" }); });
var templateObject_1;
//# sourceMappingURL=index.js.map